module.exports = __webpack_public_path__ + "img/1F601.72bf73a7.svg";